import type { JSX, ReactNode } from 'react';

import { cn } from '@change/ds-utils';

import { CarouselDots } from './components/CarouselDots';
import { NavigationArrows } from './components/NavigationArrows';
import { useCardCarousel } from './hooks/useCardCarousel';

type CardCarouselProps = {
	items: Array<{
		key: string;
		component: ReactNode;
	}>;
};
export function CardCarousel({ items }: CardCarouselProps): JSX.Element {
	const {
		scrollContainerRef,
		activeIndex,
		canScrollLeft,
		canScrollRight,
		handleScrollLeft,
		handleScrollRight,
		setItemRef,
	} = useCardCarousel({ itemCount: items.length });

	return (
		<div className="relative flex flex-col gap-5 md:gap-3">
			<div className="relative">
				<NavigationArrows
					canScrollLeft={canScrollLeft}
					canScrollRight={canScrollRight}
					onScrollLeft={handleScrollLeft}
					onScrollRight={handleScrollRight}
				/>
				<div
					ref={scrollContainerRef}
					className="flex w-full snap-x snap-mandatory flex-row gap-4 overflow-x-auto [ms-overflow-style:none] [scrollbar-width:none] md:gap-12"
				>
					{items.map(({ component, key }, index) => (
						<div
							key={key}
							ref={setItemRef(index)}
							className={cn('flex-shrink-0 snap-center md:min-w-full', {
								'ml-4': index === 0,
								'mr-4': index === items.length - 1,
							})}
						>
							{component}
						</div>
					))}
				</div>
			</div>
			<CarouselDots totalItems={items.length} activeIndex={activeIndex} />
		</div>
	);
}
